import React, { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import { RecordVoiceOver } from '@mui/icons-material';
import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
const styles = {
  conversation: {
    padding: 16,
    overflow: 'auto',
    maxHeight: '300px'
  },
  speakerOne: {
    color: 'rgb(0, 31, 100)'
  },
  speakerTwo: {
    color: 'rgb(110, 9, 20)'
  },
  flip: {
    transform: 'scaleX(-1)'
  },
};

const AudioDiscussion = ({ classes, transcription, blurry, onTextClick }) => {
  const isObjectTranscription = Array.isArray(transcription) &&
    transcription.length > 0 &&
    typeof transcription[0] === 'object' &&
    'start' in transcription[0];

  const handleTextClick = (startTime) => {
    if (onTextClick && typeof startTime === 'number') {
      onTextClick(startTime);
    }
  };

  const renderTextItem = (text, index, startTime, author) => {
    const isEvenIndex = author === 'client' || (!author && index % 2 === 0);

    const textProps = {
      variant: 'caption',
      className: `${isEvenIndex ?
        classes.speakerOne : classes.speakerTwo} ${blurry || ''}`,
      onClick: () => handleTextClick(startTime),
      children: text,
      sx: {
        ...(startTime !== null && {
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
          }
        })
      }
    };

    if (isEvenIndex) {
      return [
        <Grid key={`icon-${index}`} item xs={1}>
          <RecordVoiceOver color="primary" />
        </Grid>,
        <Grid key={`text-${index}`} item xs={9}>
          <Typography {...textProps} />
        </Grid>,
        <Grid key={`empty-${index}`} item xs={2}></Grid>,
      ];
    }
    return [
      <Grid key={`empty-${index}`} item xs={2}></Grid>,
      <Grid key={`text-${index}`} item xs={9}>
        <Typography {...textProps} />
      </Grid>,
      <Grid key={`icon-${index}`} item xs={1}>
        <RecordVoiceOver className={classes.flip} color="secondary" />
      </Grid>
    ];

  };

  const renderTranscriptionItems = useCallback(() => {
    if (!isObjectTranscription) {
      const text = typeof transcription === 'string' ? transcription : '';
      return text.split('\n').map((t, i) => renderTextItem(t, i, null));
    }

    return transcription.map((item, i) =>
      renderTextItem(item.text, i, item.start, item.author)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transcription]);

  return (
    <Grid container item className={classes.conversation}>
      {renderTranscriptionItems().flat()}
    </Grid>
  );
};

export default withStyles(AudioDiscussion, styles);
